import { Preferences } from './WebPreferences';

const KEYS = {
  GAME_COUNT: 'rating_game_count',
  RATED: 'rating_completed',
  NEVER: 'rating_never',
};

export async function incrementGameCount() {
  const { value } = await Preferences.get({ key: KEYS.GAME_COUNT });
  const count = (parseInt(value) || 0) + 1;
  await Preferences.set({ key: KEYS.GAME_COUNT, value: String(count) });
  return count;
}

export async function shouldShowRatingPrompt() { return false; }
export async function markRated() {}
export async function markNever() {}
export async function hasRated() { return false; }
export function openPlayStore() {}
